import { lessonNoteParts } from "@wmf/shared/notes";

/** Only Hub resource references become links; all other tutor text stays text. */
export function LessonNoteText({ content }: { content: string }) {
  return <>{lessonNoteParts(content).map((part, index) => part.href
    ? <a key={index} href={part.href} target="_blank" rel="noreferrer">{part.text}</a>
    : part.text)}</>;
}
